<script setup>
import { useRouter } from "vue-router";
import EmptyState from "@/components/ui/EmptyState.vue";
import ButtonApp from "@/components/common/other/ButtonApp.vue";
import { getManagerAccessFallbackPath } from "@/constants/managerAccess";

const router = useRouter();

const goToAvailablePage = () => {
  router.replace(getManagerAccessFallbackPath());
};
</script>

<template>
  <div class="container-fluid mt-2">
    <div class="card supercard bmn-card-flush-mobile">
      <div class="card-body">
        <EmptyState
          title="Немає доступу"
          description="У вас невистачає доступів для перегляду даної сторінки. Зверніться, будь ласка, до Власника акаунта для вирішення цієї проблеми"
        >
          <template #icon>
            <i class="material-icons">lock</i>
          </template>

          <ButtonApp class="mb-3" @click="goToAvailablePage">
            Перейти на доступну сторінку
          </ButtonApp>
        </EmptyState>
      </div>
    </div>
  </div>
</template>
